module.exports = {
      id: "new-label-usage",
      viewBox: "0 0 26 10",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#new-label",
      toString: function () {
        return this.url;
      }
    }